// Pure data-prep helpers for TaskModal — extracted to keep TaskModal.jsx under max-lines.
import { generateKeyBetween } from 'fractional-indexing';

const processDateData = (processedData) => {
  if (processedData.date && typeof processedData.date === 'string') {
    processedData.date = new Date(processedData.date + 'T00:00:00');
  }
};

const normalizeDate = (date) => {
  if (date instanceof Date) return date;
  if (date?.toDate) return date.toDate();
  return date ? new Date(date) : null;
};

const checkDateChanged = (oldDate, newDate) => {
  if (!newDate) return false;
  if (!oldDate) return true;
  return oldDate.toDateString() !== newDate.toDateString();
};

const getSiblingsSortedByDate = (allTasks, parentId, taskId) => {
  return allTasks
    .filter(
      (t) =>
        (t.parentId || null) === (parentId || null) &&
        t.id !== taskId &&
        t.date,
    )
    .map((t) => ({
      ...t,
      _dateObj: t.date?.toDate ? t.date.toDate() : new Date(t.date),
    }))
    .filter((t) => !isNaN(t._dateObj.getTime()))
    .sort((a, b) => a._dateObj - b._dateObj);
};

const calculateNewOrderKey = (prevSibling, nextSibling) => {
  let keyA = prevSibling?.orderKey ?? null;
  let keyB = nextSibling?.orderKey ?? null;
  if (keyA !== null && keyB !== null && keyA >= keyB) {
    [keyA, keyB] = [keyB, keyA];
  }
  return generateKeyBetween(keyA, keyB);
};

const updateOrderKeyIfDateChanged = (
  taskDataForFirestore,
  taskId,
  initialTask,
  allTasks,
  newDate,
) => {
  if (!taskId || !initialTask) return;

  const oldDate = normalizeDate(initialTask.date);
  const dateChanged = checkDateChanged(oldDate, newDate);
  if (!dateChanged) return;

  const siblings = getSiblingsSortedByDate(
    allTasks,
    initialTask.parentId,
    taskId,
  );
  const insertIndex = siblings.findIndex((t) => t._dateObj > newDate);
  const prevSibling =
    insertIndex > 0
      ? siblings[insertIndex - 1]
      : insertIndex === -1
        ? siblings[siblings.length - 1]
        : null;
  const nextSibling = insertIndex >= 0 ? siblings[insertIndex] : null;

  const newOrderKey = calculateNewOrderKey(prevSibling, nextSibling);
  taskDataForFirestore.orderKey = newOrderKey;
};

export const prepareTaskData = (
  taskDataFromForm,
  taskId,
  initialTask,
  allTasks,
) => {
  const processedData = { ...taskDataFromForm };
  processDateData(processedData);

  const taskDataForFirestore = {
    ...processedData,
    duration: parseInt(processedData.duration, 10) || 0,
  };

  updateOrderKeyIfDateChanged(
    taskDataForFirestore,
    taskId,
    initialTask,
    allTasks,
    processedData.date,
  );
  return taskDataForFirestore;
};
